<template>
  <div class="c-document-files">
    <div
      v-for="(item) in data"
      :key="item.key"
    >
      <c-document-row
        :data="item"
      />
    </div>
  </div>
</template>

<script>
import CDocumentRow from './CDocumentRow.vue'

export default {
  name: 'CDocumentFiles',
  components: {
    CDocumentRow
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">

</style>
